<template>
  <div class="order">
    <div class="order_nav">
      <form action="/">
        <van-search
          v-model="value"
          show-action
          placeholder="请输入要搜索的订单编号/商品名"
          @search="onSearch"
          @cancel="onCancel"
        />
      </form>
    </div>
    <div class="all">
      <van-tabs
        sticky
        @click="onClick"
        scroll="{ scrollTop: 64, isFixed: true }"
      >
        <van-tab title="待发货">
          <allOrder
            v-if="active == 0"
            orderStyle="20"
            :gooodsName="gooodsName"
            :isSearch="'1'"
          />
        </van-tab>
        <van-tab title="待收货">
          <allOrder
            v-if="active == 1"
            orderStyle="30"
            :gooodsName="gooodsName"
            :isSearch="'1'"
          />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import allOrder from "./allOrder.vue";
export default {
  components: {
    navbar,
    allOrder,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      righticon: require("@/assets/purchaseSupplier/common/search.png"),
      active: 0,
      value: "",
      gooodsName: "",
    };
  },
  methods: {
    onClick(name) {
      this.active = name;
    },
    onCancel() {
      this.$router.go(-1);
    },
    onSearch(val) {
      this.gooodsName = val;
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;

    .van-search {
      height: 4.4rem;
      line-height: 4.4rem;
      padding: 0 0.8rem 1.4rem 1.6rem;
      box-sizing: border-box;

      .van-search__content {
        padding-left: 2rem;
        line-height: 3rem;
        font-size: 1.4rem;

        .van-cell {
          height: 3rem;
          border-radius: 1.5rem;
        }
      }
    }
  }

  .all {
    padding-top: 8.8rem;
    box-sizing: border-box;
    height: 100%;

    /deep/.van-tabs {
      min-height: 100%;

      .van-sticky {
        position: fixed;
        top: 8.8rem;
        width: 100%;
        z-index: 2;

        .van-tab {
          font-size: 1.4rem;
          color: #999;
          font-weight: 400;
          padding: 0 0.8rem;
        }

        .van-tab--active {
          color: #333;
          font-weight: 700;
        }

        .van-tabs__line {
          background: -webkit-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            to right,
            #fc740c,
            #f41a3c
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(to right, #fc740c, #f41a3c);
          width: 9.8rem;
          height: 0.3rem;
        }
      }
    }
  }
}
</style>




